import { amountRegex, nameRegex, numberRegex } from 'Constants/regularExpression';

const Form_Details = [{
    page_details: {
        form_name: 'company_setup_form',
        form_label: 'Company Setup Form',
        request_type: 'web',
        sub_sections: {
            pricing_details: {
                name: 'pricing_details',
                label: 'Details',
                can_hide: false,
                hidden: false,
                list: [
                    {
                        label: 'Student Count', regex: amountRegex, name: 'student_strength', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    },
                    // {
                    //     label: 'Free SMS Count', regex: numberRegex, name: 'free_sms_count', md: 4, className: 'w-90-per', required: false,
                    //     id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    // },
                    // {
                    //     label: 'Free Email Count', regex: numberRegex, name: 'free_email_count', md: 4, className: 'w-90-per', required: false,
                    //     id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    // },
                    // {
                    //     label: 'Additional SMS Cost per sms', regex: amountRegex, name: 'additional_sms_cost', md: 4, className: 'w-90-per', required: false,
                    //     id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    // },
                    // {
                    //     label: 'Additional Email Cost per email', regex: amountRegex, name: 'additional_email_cost', md: 4, className: 'w-90-per', required: false,
                    //     id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    // },
                    // {
                    //     label: 'Additional IVR Service Cost', regex: amountRegex, name: 'additional_ivr_service_cost', md: 4, className: 'w-90-per', required: false,
                    //     id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    // },
                ]
            },
            terms: {
                name: 'terms',
                label: 'Payment Terms',
                can_hide: false,
                hidden: false,
                is_dynamic: true,
                list: [
                    {
                        label: 'Term Name', regex: nameRegex, name: 'term_name', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 100
                    },
                    {
                        label: 'Term Amount Receive Date', regex: null, name: 'term_receive_date', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'date', minDate: new Date('2020-01-02'), maxDate: new Date('2050-01-01'), parentMinDate: 'order_date'
                    },
                    {
                        label: 'Amount in %', regex: amountRegex, name: 'amount_percentage', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 100, minNumber: 0
                    },
                    {
                        label: 'Amount in Rs', regex: amountRegex, name: 'amount_rs', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 1000000, minNumber: 0
                    },
                ]
            },
            pricing_services: {
                name: 'pricing_services',
                label: 'Services Selected',
                can_hide: false,
                hidden: false,
                is_dynamic: true,
                list: [
                    {
                        label: 'Service Name', regex: nameRegex, name: 'service_name', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 100
                    },
                    {
                        label: 'Item Count', regex: numberRegex, name: 'item_count', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '1', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    },
                    {
                        label: 'Service Amount', regex: amountRegex, name: 'service_amount', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 1000000, minNumber: 0
                    },
                    {
                        label: 'GST in %', regex: amountRegex, name: 'service_gst_percentage', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 100, minNumber: 0
                    },
                    {
                        label: 'Service Duration', regex: amountRegex, name: 'service_duration', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'number', maxNumber: 100, minNumber: 0,
                        endAdornment: 'Years', helperText: 'Measured in years'
                    },
                    {
                        label: 'Order Date', regex: null, name: 'order_date', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'date', minDate: new Date('2020-01-02'), maxDate: new Date()
                    },
                    {
                        label: 'Service End Date', regex: null, name: 'service_end_date', md: 4, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'date', minDate: new Date(), maxDate: null
                    },
                    {
                        label: 'Notes', regex: nameRegex, name: 'notes', md: 4, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 250
                    },
                ]
            }
        }
    }
}];

export const ModulesConfig = {
    // Institute_Setup: {
    //     label: 'Institute Setup',
    //     options: [
    //         { id: 'school_building_list', name: 'School Building List' },
    //         { id: 'institution_address', name: 'Institution Address' },
    //         { id: 'school_timings', name: 'School Timings' },
    //         { id: 'visitor_details', name: 'Visitor Details' },
    //         { id: 'reason_list', name: 'Reason List' }
    //     ]
    // },
    // Student_Management: {
    //     label: 'Student Management',
    //     options: [
    //         { id: 'student_enquiry', name: 'Student Enquiry' },
    //         { id: 'student_application', name: 'Student Application' },
    //         { id: 'student_admission', name: 'Student Admission' },
    //         { id: 'student_list', name: 'Student List' },
    //         { id: 'student_homework', name: 'Student Homework' },
    //         { id: 'student_timetable', name: 'Student TimeTable' }
    //     ]
    // },
    // Finance: {
    //     label: 'Finance',
    //     options: [
    //         { id: 'fee_types', name: 'Fee Types' },
    //         { id: 'fee_plan', name: 'Fee Plan' },
    //         { id: 'fee_term', name: 'Fee Term' },
    //         { id: 'fee_collection', name: 'Fee Collection' },
    //         { id: 'fee_report', name: 'Fee Report' },
    //         { id: 'cashbook_finance', name: 'Cashbook' },
    //         { id: 'miscellaneous', name: 'Miscellaneous' }
    //     ]
    // },
    // Enrollment: {
    //     label: 'Enrollment',
    //     options: [
    //         { id: 'student_enrollment', name: 'Student Enrollment' },
    //         { id: 'subject_assignment', name: 'Subject Assignment' },
    //         { id: 'promote_student', name: 'Promote Student' },
    //         { id: 'shuffle_student', name: 'Shuffle Student' }
    //     ]
    // },
    // Concession: {
    //     label: 'Concession',
    //     options: [
    //         { id: 'concession_type', name: 'Concession Type' },
    //         { id: 'concession_plan', name: 'Concession Plan' }
    //     ]
    // },
    // Cashbook: {
    //     label: 'Cashbook',
    //     options: [
    //         { id: 'cashbook', name: 'Cashbook' }
    //     ]
    // },
    // Staff_Management: {
    //     label: 'Staff Management',
    //     options: [
    //         { id: 'add_staffs', name: 'Add Staffs' },
    //         { id: 'staff_subject_assignment', name: 'Staff Subject Assignment' },
    //         { id: 'staff_shift_assignment', name: 'Staff Shift Assignment' },
    //         { id: 'staff_attendance', name: 'Staff Attendance' },
    //         { id: 'view', name: 'View' },
    //         { id: 'organisation_chart', name: 'Organisation Chart' }
    //     ]
    // },
    // Attendance: {
    //     label: 'Attendance',
    //     options: [
    //         { id: 'staff_attendance_report', name: 'Staff Attendance and Report' },
    //         { id: 'student_attendance_report', name: 'Student Attendance and Report' }
    //     ]
    // },
    // Expense_For_Staff: {
    //     label: 'Expense For Staff',
    //     options: [
    //         { id: 'expense_types', name: 'Expense Types' },
    //         { id: 'expense_plan', name: 'Expense Plan' }
    //     ]
    // },
    // Bank_Management: {
    //     label: 'Bank Management',
    //     options: [
    //         { id: 'bank_list', name: 'Bank List' },
    //         { id: 'fee_type_bank', name: 'Fee Type' },
    //         { id: 'bank_mapping', name: 'Bank Mapping' }
    //     ]
    // },
    // Certificate_Generation: {
    //     label: 'Certificate Generation',
    //     options: [
    //         { id: 'study_certificate', name: 'Study Certificate' },
    //         { id: 'admission_abstract', name: 'Admission Abstract' }
    //     ]
    // },
    // Online_Fees_Payment: {
    //     label: 'Online Fees Payment',
    //     options: [
    //         { id: 'fee_payment_upi', name: 'Fee Payment via UPI' },
    //         { id: 'fee_payment_cards', name: 'Fee Payment via Credit/Debit Cards' },
    //         { id: 'fee_payment_netbanking', name: 'Fee Payment via Netbanking' }
    //     ]
    // },
    // Mobile_Application: {
    //     label: 'Mobile Application',
    //     options: [
    //         { id: 'mobile_banners', name: 'Mobile Banners' },
    //         { id: 'student_assignments_notifications', name: 'Student Assignments Notifications' },
    //         { id: 'student_fee_notifications', name: 'Student Fee Notifications' },
    //         { id: 'student_exam_notifications', name: 'Student Exam Notifications' },
    //         { id: 'timetable_view', name: 'TimeTable View' }
    //     ]
    // },
    // Notifications: {
    //     label: 'Notifications',
    //     options: [
    //         { id: 'email', name: 'Email' },
    //         { id: 'sms', name: 'SMS' },
    //         { id: 'push', name: 'Push' }
    //     ]
    // },
    // Transport: {
    //     label: 'Transport',
    //     options: [
    //         { id: 'vehicle_driver_details', name: 'Vehicle and Driver Details' },
    //         { id: 'route_planning', name: 'Route Planning' },
    //         { id: 'live_tracking', name: 'Live Tracking' },
    //         { id: 'prices_km_area', name: 'Prices based on Kilometers / Area' },
    //         { id: 'student_address_details', name: 'Student Address Details' }
    //     ]
    // },
    // Leave_Management_Staff_Student: {
    //     label: 'Leave Management Staff Student',
    //     options: [
    //         { id: 'leave_types', name: 'Leave Types' },
    //         { id: 'leave_plan', name: 'Leave Plan' },
    //         { id: 'apply_leave', name: 'Apply Leave' },
    //         { id: 'approve_leave', name: 'Approve Leave (For Admin or Principal)' }
    //     ]
    // },
    // Exam_Management: {
    //     label: 'Exam Management',
    //     options: [
    //         { id: 'exam_types', name: 'Exam Types' },
    //         { id: 'exam_schedule', name: 'Exam Schedule' },
    //         { id: 'hall_ticket', name: 'Hall Ticket' },
    //         { id: 'result_config_summary', name: 'Result Configuration and Summary' }
    //     ]
    // },
    // Services: {
    //     label: 'Services',
    //     options: [
    //         { id: 'mobile_app_android_ios', name: 'Mobile Application Android / IOS' },
    //         { id: 'admin_support', name: 'Admin Support' },
    //         { id: 'gallery_storage_2gb', name: 'Gallery Storage 2Gb' }
    //     ]
    // },
    // Library_Management: {
    //     label: 'Library Management',
    //     options: [
    //         { id: 'add_books', name: 'Add Books' },
    //         { id: 'library_membership', name: 'Library Membership' },
    //         { id: 'issue_return_books', name: 'Issue/Return Books' },
    //         { id: 'fine', name: 'Fine' },
    //         { id: 'checkout_checkin', name: 'Checkout and Checkin' }
    //     ]
    // },
    // Daily_Activities: {
    //     label: 'Daily Activities',
    //     options: [
    //         { id: 'home_work', name: 'Home Work' },
    //         { id: 'visitor_management', name: 'Visitor Management' },
    //         { id: 'chat_system', name: 'Chat System' }
    //     ]
    // },
    // Pay_Roll: {
    //     label: 'Pay Roll',
    //     options: [
    //         { id: 'leave_management_payroll', name: 'Leave Management' },
    //         { id: 'salary_structure_payslip', name: 'Salary Structure and Payslip' }
    //     ]
    // },
    // LMS: {
    //     label: 'LMS',
    //     options: [
    //         { id: 'quiz_management', name: 'Quiz Management' },
    //         { id: 'lesson_planning', name: 'Lesson Planning' }
    //     ]
    // },
    // Hostel_Management: {
    //     label: 'Hostel Management',
    //     options: [
    //         { id: 'hostel', name: 'Hostel' }
    //     ]
    // },
    // Inventory_Management: {
    //     label: 'Inventory Management',
    //     options: [
    //         { id: 'store', name: 'Store' }
    //     ]
    // }
};

export default Form_Details;
